// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Branch Tables Component Styles */
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
/* Accordion Header with Button */
::ng-deep .mat-expansion-panel-header {
  position: relative;
}
::ng-deep .mat-expansion-panel-header .mat-content {
  width: 100%;
  margin-right: 16px;
}
::ng-deep .mat-expansion-panel-header .mat-content .mat-expansion-panel-header-title {
  width: auto;
  margin-right: 0;
}
::ng-deep .mat-expansion-panel-header .mat-content .mat-expansion-panel-header-title .header-with-button {
  display: flex;
  align-items: center;
  width: 100%;
}
::ng-deep .mat-expansion-panel-header .mat-content .mat-expansion-panel-header-title .header-with-button .panel-title-text {
  flex: 0 0 auto;
  margin-right: 24px;
}
::ng-deep .mat-expansion-panel-header .mat-content .mat-expansion-panel-header-title .header-with-button .add-branch-table-button {
  position: absolute;
  right: 48px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1976d2;
  white-space: nowrap;
}
::ng-deep .mat-expansion-panel-header .mat-content .mat-expansion-panel-header-title .header-with-button .add-branch-table-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.branch-table-container {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
}

.no-branch-table {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}
.no-branch-table h4 {
  margin: 0;
  font-weight: 400;
}

/* Edit Mode Styles */
.branch-tables-section {
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #007bff;
}

/* Old styles - no longer used after moving button to header
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    color: #333;
    font-weight: 500;
  }
}

.add-table-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
}
*/
/* Selected Tables List */
.selected-tables-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.branch-table-item {
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-info {
  margin-bottom: 12px;
}
.table-info h4 {
  margin: 0 0 4px 0;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.table-info .table-description {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.table-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-btn.view-btn {
  background-color: #17a2b8;
  color: white;
}
.action-btn.view-btn:hover {
  background-color: #138496;
}
.action-btn.edit-btn {
  background-color: #ffc107;
  color: #212529;
}
.action-btn.edit-btn:hover {
  background-color: #e0a800;
}
.action-btn.remove-btn {
  background-color: #dc3545;
  color: white;
}
.action-btn.remove-btn:hover {
  background-color: #c82333;
}

/* Notes Section - matching PTT style */
.notes-section {
  margin: 16px 0;
  padding: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.notes-section .notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.notes-section .notes-header h5 {
  margin: 0;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}
.notes-section .notes-header .add-note-container .add-note-btn {
  color: #1976d2;
  border: 1px solid #1976d2;
  background-color: white;
}
.notes-section .notes-header .add-note-container .add-note-btn ::ng-deep mat-icon {
  margin-right: 4px;
}
.notes-section .notes-header .add-note-container .add-note-btn:hover {
  background-color: #e3f2fd;
}
.notes-section .notes-header .add-note-container .add-note-btn:disabled {
  background-color: #f5f5f5;
  color: #999;
  border-color: #ddd;
  cursor: not-allowed;
}
.notes-section .common-notes-list .common-note-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}
.notes-section .common-notes-list .common-note-item .note-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.notes-section .common-notes-list .common-note-item .note-content .note-code {
  font-weight: 600;
  color: #1976d2;
  flex: 1;
  cursor: help;
}
.notes-section .common-notes-list .common-note-item .note-content .readonly-indicator {
  font-size: 11px;
  padding: 2px 6px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 12px;
  color: #666;
  margin-left: 8px;
  white-space: nowrap;
}
.notes-section .common-notes-list .common-note-item .note-content .note-actions {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}
.notes-section .common-notes-list .common-note-item .note-content .note-actions .remove-note-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: #fff;
  color: #dc3545;
  padding: 0;
  min-width: auto;
  width: 28px;
  height: 28px;
}
.notes-section .common-notes-list .common-note-item .note-content .note-actions .remove-note-btn:hover {
  background-color: #f8f9fa;
}
.notes-section .common-notes-list .common-note-item .note-content .note-actions .remove-note-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.notes-section .common-notes-list .common-note-item .note-content .note-actions .remove-note-btn .fa-trash-can {
  font-size: 16px;
  color: #dc3545;
}
.notes-section .common-notes-list .common-note-item:last-child {
  margin-bottom: 0;
}
.notes-section .no-notes .empty-text {
  margin: 0;
  color: #666;
  font-size: 14px;
  font-style: italic;
}

/* Sync Warning Message */
.sync-warning-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin: 16px 0;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  color: #856404;
}
.sync-warning-message .warning-icon {
  color: #ffc107;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.sync-warning-message .warning-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
}

/* Branch Table Notes Section - matching PTT style */
.branch-table-notes-section {
  margin-top: 16px;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 12px;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-text-content .note-type {
  font-size: 11px;
  font-weight: 600;
  color: #666;
  background-color: #f0f0f0;
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-text-content .note-text {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  margin-left: auto;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions .edit-note-btn {
  min-width: auto;
  width: 32px;
  height: 32px;
  padding: 0;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions .edit-note-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions .remove-note-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: #fff;
  color: #dc3545;
  padding: 0;
  min-width: auto;
  width: 32px;
  height: 32px;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions .remove-note-btn:hover {
  background-color: #f8f9fa;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions .remove-note-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item .note-content .note-actions .remove-note-btn .fa-trash-can {
  font-size: 16px;
  color: #dc3545;
}
.branch-table-notes-section .branch-table-notes-list .branch-table-note-item:last-child {
  margin-bottom: 0;
}

.common-notes, .free-text-notes {
  margin-bottom: 12px;
}

.free-text-input {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}
.free-text-input textarea {
  flex: 1;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  resize: vertical;
  min-height: 40px;
  font-family: inherit;
}
.free-text-input textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.add-note-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.add-note-btn:hover {
  background-color: #218838;
}
.add-note-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Empty State */
.empty-selection {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  background-color: white;
  border: 1px dashed #dee2e6;
  border-radius: 6px;
}
.empty-selection p {
  margin: 0;
  font-size: 14px;
}

/* Comments Section */
.comments-container {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 2px solid #dee2e6;
}

/* Table Header Styles */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dee2e6;
}
.table-header .table-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.table-header .table-header-left h4 {
  margin: 0;
  color: #006aad;
  font-size: 18px;
  font-weight: 500;
}
.table-header .table-header-left .branch-name-link {
  padding: 0 4px;
  min-width: 0;
  line-height: normal;
  height: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.table-header .table-header-left .branch-name-link .branch-name-text {
  margin: 0;
  color: #006aad;
  font-size: 18px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.table-header .table-header-left .branch-name-link .branch-edit-icon {
  font-size: 0.9rem;
  width: 0.9rem;
  height: 0.9rem;
  color: #006aad;
  opacity: 0.7;
}
.table-header .table-header-left .branch-name-link:hover .branch-edit-icon {
  opacity: 1;
}
.table-header .table-type {
  margin: 0;
  color: #666;
  font-size: 14px;
  font-style: italic;
}

.remove-table-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: #fff;
  color: #dc3545;
  padding: 0;
}
.remove-table-btn:hover {
  background-color: #f8f9fa;
}
.remove-table-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Legend compare section — shown in compare mode in place of app-branch-table-display-footer */
.compare-legend-section {
  margin-top: 8px;
}
.compare-legend-section .compare-section-label {
  color: #0b2d71;
  font-weight: bolder;
  margin-bottom: 0;
}
.compare-legend-section .compare-section-hr {
  color: #0b2d71;
  border-top: 0.1em solid;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

/* Branch Tables List Styles */
.branch-tables-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.branch-table-item {
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.branch-table-content .table-display-container {
  margin-bottom: 16px;
}

.sync-branch-btn {
  transition: all 0.2s ease-in-out;
}
.sync-branch-btn.sync-available {
  color: #ff9800;
}
.sync-branch-btn.sync-available mat-icon {
  color: #ff9800;
  animation: rotate 1s ease-in-out;
}
.sync-branch-btn.sync-available:hover {
  color: #f57c00;
}
.sync-branch-btn.sync-available:hover mat-icon {
  color: #f57c00;
}
.sync-branch-btn.sync-current {
  color: #4caf50;
  cursor: default;
}
.sync-branch-btn.sync-current mat-icon {
  color: #4caf50;
}
.sync-branch-btn.sync-loading {
  color: #2196f3;
  cursor: wait;
}
.sync-branch-btn.sync-loading mat-spinner {
  color: #2196f3;
}
.sync-branch-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.table-header .table-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.table-header .table-header-left h4 {
  flex: 1;
  margin: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
